export default "__VITE_ASSET__jfGa0C7c__"